import {h} from 'ui/Framework';

export default h('svg', {
  width: '39',
  height: '40',
  viewBox: '-1 -1 41 42',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', {
        transform: 'translate(0 1)'
      }, [
        h('rect', {
          stroke: '#21304A',
          strokeWidth: '2',
          fill: 'none',
          y: '1.5',
          width: '39',
          height: '37',
          rx: '2'
        }),
        h('path', {
          d: 'M1 9.21h36',
          stroke: '#21304A',
          strokeWidth: '2',
          strokeLinecap: 'square'
        }),
        h('path', {
          d: 'M8 4.26v-4M31 4.26v-4',
          stroke: '#21304A',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }),
        h('rect', {
          fill: '#21304A',
          x: '7',
          y: '14.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '18',
          y: '14.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '7',
          y: '30.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '18',
          y: '30.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '7',
          y: '22.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '16',
          y: '20.211',
          width: '7',
          height: '7',
          rx: '4'
        }),
        h('rect', {
          fill: '#21304A',
          x: '29',
          y: '14.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '29',
          y: '30.211',
          width: '3',
          height: '3',
          rx: '1'
        }),
        h('rect', {
          fill: '#21304A',
          x: '29',
          y: '22.211',
          width: '3',
          height: '3',
          rx: '1'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-calendar.es6.js